import { useNavigate } from "react-router-dom";
import InputField from "../../common_component/component/InputField";
import { ADD_ICON, VIEW_ICON } from "../../cufront-assets/icons/Icons";
import "../css/PaymentVoucherTable.css";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useEffect, useState } from "react";
import moment from "moment";
import CuPagination from "../../common_component/component/CuPagination";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import CuScreenLoader from "../../common_component/component/CuScreenLoader";
import { dateConvertToPayloadBookingFormat } from "../../components/admin/setup/helper/Helper";
import { IoCloseOutline } from "react-icons/io5";
import PaginationComponent from "../../common_component/component/PaginationComponent";

const tableCols = [
  { id: 1, label: "Customer" },
  { id: 2, label: "Transaction ID" },
  { id: 3, label: "Amount Recieved" },
  { id: 4, label: "Date" },
  { id: 5, label: "Type" },
  { id: 6, label: "Action" },
];

const PaymentVoucherTable = ({ customerId }) => {
  const [tableData, setTableData] = useState([]);
  const [totalRecieved, setTotalRecieved] = useState(0);
  const [pagination, setPagination] = useState({ limit: 5, activePage: 1 });
  const [searchInput, setSearchInput] = useState("");
  const [dateFilter, setDateFilter] = useState({ startDate: "", endDate: "" });

  const [currentPage, setCurrentPage] = useState(1);

  const [perPageLimit, setPerPageLimit] = useState(5);

  const dateFilterQuery = `date=${dateFilter?.startDate}to${dateFilter?.endDate}`;

  // const dateFilterQuery = `&filter[transaction_date][_between]=[${dateFilter?.startDate}, ${dateFilter?.endDate}]`;
  // const searchQuery = `&search=${searchInput}`;
  // const customerQuery = `&filter[customer_id][_eq]=${customerId}`;
  const navigate = useNavigate();
  const [clinic] = useAtom(clinicAtom);

  // const { data: paymentVoucherData, isLoading } = useItemsFilter(
  //   ApiEndPoint.BILLING_PAYMENT_VOUCHER,
  //   `?fields=id,customer_id.institution_name,transaction_id,amount_recieved,transaction_date,type.type
  //    ${searchInput?.length > 0 ? searchQuery : ""}${
  //     customerId ? customerQuery : ""
  //   }&page=${pagination?.activePage}${
  //     dateFilter?.startDate && dateFilter?.endDate ? dateFilterQuery : ""
  //   }&limit=${pagination?.limit}&sort=-transaction_date&meta=filter_count`
  // );

  let query = `?action=getBillingPaymentVoucher&frontend=True&page=${currentPage}&records_number=${perPageLimit}&clinic_id=${
    clinic?.id
  }&${customerId ? `institution_customer=${customerId}` : ``}`;

  if (dateFilter?.startDate) {
    query = `?action=getBillingPaymentVoucher&frontend=True&page=${currentPage}&records_number=${perPageLimit}&clinic_id=${
      clinic?.id
    }&${
      customerId
        ? `institution_customer=${customerId}${dateFilterQuery}`
        : `${dateFilterQuery}`
    }`;
  }

  const { data: paymentVoucherData, isLoading } = useItemsFilter(
    ApiEndPoint.BILLING_PAYMENT_VOUCHER,
    // `?action=getBillingPaymentVoucher&frontend=True&clinic_id=${clinic?.id}&${
    //   customerId ? `institution_customer=${customerId}${dateFilterQuery}` : `${dateFilterQuery?.startDate}`
    // }`
    query,
    clinic ? true : false,
    "invoice"
  );

  const totalDataCount = paymentVoucherData?.total_count;

  const totalPages = Math.ceil(totalDataCount / perPageLimit);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleGoToPage = (event) => {
    const page = parseInt(event.target.value);
    // if (page > 0 && page <= totalPages) {
    //   setCurrentPage(page);
    // }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleGoToPage(event);
    }
  };

  const handleDateFilter = (e) => {
    const toDate = new Date(e.target.value);

    const formattedDate = dateConvertToPayloadBookingFormat(toDate);

    //(formattedDate, "formattedDate");

    if (e.target.id == "endDate") {
      setDateFilter((prev) => ({
        ...prev,
        endDate: formattedDate,
      }));
    } else if (e.target.id == "startDate") {
      setDateFilter((prev) => ({
        ...prev,
        startDate: formattedDate,
      }));
    }
  };
  //(dateFilterQuery, "dateFilterQuery");

  useEffect(() => {
    if (paymentVoucherData) {
      let totalRecieved = 0;
      const tableData = paymentVoucherData?.data?.map((ele) => {
        totalRecieved += ele?.amount_recieved;
        return {
          id: ele?.id,
          customer: ele?.customer_id?.institution_name,
          transaction_id: ele?.transaction_id,
          amount_recieved: ele?.amount_recieved,
          transaction_date: moment(ele?.transaction_date).format("D MMMM YYYY"),
          type: ele?.type?.type,
        };
      });
      setTotalRecieved(totalRecieved);
      setTableData(tableData);
    }
  }, [paymentVoucherData]);

  const handleAddVoucher = () => {
    navigate(`/new/invoice?option=paymentvoucher&mode=create`);
  };

  const clearDateInputs = () => {
    setDateFilter({ startDate: "", endDate: "" });
  };
  //(dateFilter, "dateFilter");

  return (
    <div className="cu-payment-voucher-table-main">
      <div className="cu-payment-voucher-top-btns">
        <div className="cu-payment-voucher-search">
          {/* <InputField
            type={"text"}
            placeholder={"search"}
            search={true}
            onChange={(e) => setSearchInput(e.target.value)}
            loading={isLoading}
          /> */}
        </div>
        <div className="cu-payment-voucher-date-filter">
          <InputField
            id={"startDate"}
            type={"date"}
            value={dateFilter?.startDate?.split("T")[0]}
            label={"From"}
            onChange={handleDateFilter}
          />
          <InputField
            type={"date"}
            value={dateFilter?.endDate.split("T")[0]}
            label={"To"}
            id={"endDate"}
            onChange={handleDateFilter}
          />
          {(dateFilter?.startDate || dateFilter?.endDate) && (
            <IoCloseOutline
              className="mt-7 cursor-pointer"
              size={25}
              onClick={clearDateInputs}
            />
          )}
        </div>
      </div>
      <div>
        <div className="cu-payment-voucher-total-recieved">
          {!customerId && (
            <div
              className="cu-payment-voucher-add-btn"
              onClick={handleAddVoucher}
            >
              <span>
                <img src={ADD_ICON} alt="add" width={"24px"} height={"24px"} />
              </span>
              <span>Add Payment Voucher</span>
            </div>
          )}
          <div>
            Total Recieved Amount:{" "}
            <span style={{ fontWeight: "700" }}>{totalRecieved}</span>
          </div>
        </div>
        <div className="cu-payment-voucher-table">
          <table>
            <thead className="cu-payment-voucher-table-header">
              <tr>
                {tableCols.map((tcol) =>
                  (tcol.label === "Customer" || tcol.label === "Action") &&
                  customerId ? (
                    <></>
                  ) : (
                    <th key={tcol.id}>{tcol.label}</th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {tableData?.map((data) => {
                return (
                  <tr key={data?.id}>
                    {Object.keys(data)?.map((key, idx) => {
                      if (key === "customer" && customerId) {
                        return <></>;
                      }
                      if (key !== "id") {
                        return <td key={`${data?.id}${idx}`}>{data[key]}</td>;
                      }
                    })}
                    {!customerId && (
                      <td style={{ display: "flex", justifyContent: "center" }}>
                        <img
                          src={VIEW_ICON}
                          alt="view"
                          width={"20px"}
                          height={"15px"}
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            navigate(
                              `/new/invoice?option=paymentvoucher&mode=view&id=${data?.id}`
                            )
                          }
                        />
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-3 mb-3 sm:mb-20">
        <PaginationComponent
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          handleKeyPress={handleKeyPress}
          perPageLimit={perPageLimit}
          setPerPageLimit={setPerPageLimit}
        />
      </div>
      {isLoading && <CuScreenLoader />}
    </div>
  );
};

export default PaymentVoucherTable;
